import { gql } from '__generated__';

export default gql(`
  mutation DisableMolliePaymentMethod($input: ToggleMolliePaymentMethodInput!) {
    disableMolliePaymentMethod(input: $input) {
      id
      enabled
    }
  }
`);
